import { useState } from 'react';
import atraq from '../../assets/atraq.png'
import { useSelector } from "react-redux";
import usePocketBaseAuth from '../../hooks/Auth/usePocketBaseAuth';

const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Get user details from Redux store
  const { user } = useSelector((state) => state.auth);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  console.log("user", user);
  const { logout } = usePocketBaseAuth();

  const handleLogout = () => {
    logout();
  };
    
  return (
    <header className="bg-[#0e1726] text-white p-4 flex justify-between items-center">
    {/* Logo Section */}
    <div className="flex items-center space-x-2">
      <img src={atraq} alt="Logo" className="h-8 w-8" /> {/* Replace with your logo */}
      <h1 className="text-xl font-bold">ATraq</h1>
    </div>
    {/* Profile Section */}
    {user  &&
    <div className="relative">
      {/* <img
        src={user?.profileImage || defaultAvatar}
        alt="User Avatar"
        className="h-10 w-10 rounded-full cursor-pointer"
        onClick={toggleDropdown}
      /> */}
      
        <div
        onClick={toggleDropdown} 
        class="relative w-10 h-10 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-600 cursor-pointer">
            <svg class="absolute w-12 h-12 text-gray-400 -left-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"></path></svg>
        </div>


      {isDropdownOpen && (
        <ul className="absolute right-0 mt-2 w-48 bg-white text-black shadow-lg rounded-md">
          <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
            My Profile
          </li>
          <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
            Settings
          </li>
          <li 
          onClick={handleLogout}
          className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
            Logout
          </li>
        </ul>
      )}
    </div>
    }
  </header>
    );
  };
  
  export default Header;
  